import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextInput, Edit, usePermissions, useDataProvider, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import getLoadingState from '@/helpers/ui/getLoadingState.jsx';
import { DeviceForm } from '@/components/device/forms/DeviceForm.jsx';

const DeviceEditStatusInputs = ({ translate }) => (
    <>
        <Typography variant='h6' gutterBottom>
            {translate('resources.device.fields.status')}
        </Typography>
        <Box display='flex' mb='2em'>
            <Box flex={1} mr='1em'>
                <TextInput source='state' label={translate('resources.device.fields.status')} fullWidth={true} disabled />
            </Box>
            <Box flex={1}>
                <TextInput source='binState' label={translate('resources.device.fields.binStateLabel')} fullWidth={true} disabled />
            </Box>
        </Box>
    </>
);

DeviceEditStatusInputs.propTypes = {
    translate: PropTypes.func.isRequired,
};

export const DeviceEditContent = ({ handleClose, elementId }) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const dataProvider = useDataProvider();
    const [device, setDevice] = useState(null);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loadingState = getLoadingState({ isLoading, error, data: device, translate });

    useEffect(() => {
        if (elementId) {
            setIsLoading(true);
            dataProvider
                .getOne('device', { id: elementId })
                .then(({ data }) => {
                    setDevice(data);
                    setError(null);
                })
                .catch(err => {
                    console.error('Error fetching device:', err);
                    setError(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [dataProvider, elementId]);

    if (loadingState) return loadingState;

    if (isLoading || !permissions) return null;

    return (
        <Box>
            <Box className='popup-wrapper popup-wrapper-top'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.device.labels.editDeviceTitle')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            <Box className='popup-wrapper border-bottom'>
                <Box className='popup-box'>
                    <Edit id={elementId} resource='device' mutationMode='pessimistic' redirect={false}>
                        <DeviceForm EditInputs={<DeviceEditStatusInputs translate={translate} />} />
                    </Edit>
                </Box>
            </Box>
        </Box>
    );
};

DeviceEditContent.propTypes = {
    handleClose: PropTypes.func,
    elementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
